(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["deseado-coleccion"] && !Shopify.designMode) return;
  try {
    
  // Colección: entrada animada de las tarjetas y agregado rápido al carrito.
  if (!customElements.get('deseado-coleccion')) {
    customElements.define(
      'deseado-coleccion',
      class DeseadoColeccion extends HTMLElement {
        connectedCallback() {
          if (this._wired) return;
          this._wired = true;

          this.items = Array.from(this.querySelectorAll('[data-deseado-item]'));
          this.querySelectorAll('[data-deseado-agregar]').forEach((boton) => {
            boton.hidden = false;
            boton.addEventListener('click', () => this.agregar(boton));
          });

          // Entrada animada solo si hay IntersectionObserver y el usuario no
          // pidió menos movimiento. Se activa la clase recién acá: sin JS las
          // tarjetas se ven directamente, sin esperar a nada.
          const menosMovimiento = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if ('IntersectionObserver' in window && !menosMovimiento && this.items.length) {
            this.classList.add('animar');
            const io = new IntersectionObserver((entradas) => {
              entradas.forEach((e) => {
                if (e.isIntersecting) { e.target.classList.add('esta-lista'); io.unobserve(e.target); }
              });
            }, { rootMargin: '0px 0px -10% 0px', threshold: 0.15 });
            this.items.forEach((item) => io.observe(item));
            // Red de seguridad: si por lo que sea no se observan, se muestran.
            setTimeout(() => this.items.forEach((i) => i.classList.add('esta-lista')), 2500);
          }
        }

        loadEvents() {
          if (!this._events) {
            const url = this.dataset.eventsModule;
            this._events = url ? import(url).then((m) => (m && m.CartLinesUpdateEvent ? m : null)).catch(() => null) : Promise.resolve(null);
          }
          return this._events;
        }

        async agregar(boton) {
          if (boton.getAttribute('aria-busy') === 'true') return;
          const variantId = boton.dataset.variantId;
          if (!variantId) return;
          boton.setAttribute('aria-busy', 'true');
          const sectionIds = [];
          document.querySelectorAll('cart-items-component[data-section-id]').forEach((n) => { const id = n.dataset.sectionId; if (id && sectionIds.indexOf(id) === -1) sectionIds.push(id); });
          const events = await this.loadEvents();
          let deferred = null;
          if (events) {
            deferred = events.CartLinesUpdateEvent.createPromise();
            this.dispatchEvent(new events.CartLinesUpdateEvent({ action: 'add', context: 'product', lines: [{ merchandiseId: variantId, quantity: 1 }], promise: deferred.promise }));
          }
          try {
            const body = { id: variantId, quantity: 1 };
            if (sectionIds.length) body.sections = sectionIds.join(',');
            const payload = await fetch(this.dataset.cartAddUrl || '/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body) }).then((r) => r.json());
            if (payload.status) throw new Error(payload.description || payload.message || '');
            await this.settle(events, deferred, { itemCount: 1, sections: payload.sections, didError: false });
            boton.classList.add('is-added'); setTimeout(() => boton.classList.remove('is-added'), 1600);
            if (!events) { const a = window.Shopify && window.Shopify.actions; if (a && a.openCart) a.openCart(); else window.location.href = (this.dataset.cartJsonUrl || '/cart.js').replace(/\.js$/, ''); }
          } catch (error) {
            await this.settle(events, deferred, { itemCount: 1, didError: true });
            const link = boton.parentElement.querySelector('a[href]'); if (link) window.location.href = link.href;
          } finally {
            boton.setAttribute('aria-busy', 'false');
          }
        }

        async settle(events, deferred, detail) {
          if (!events || !deferred) return;
          try {
            const cart = await fetch(this.dataset.cartJsonUrl || '/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
            deferred.resolve({ cart: events.CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: Object.assign({ items: cart.items, source: 'deseado-coleccion', sourceId: this.id || 'deseado-coleccion' }, detail) });
          } catch (error) { deferred.reject(error); }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["deseado-creatupack"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('deseado-creatupack')) {
    customElements.define(
      'deseado-creatupack',
      class DeseadoCreaTuPack extends HTMLElement {
        connectedCallback() {
          if (this._wired) return;
          this._wired = true;

          this.form = this.querySelector('form[action*="/cart/add"]');
          this.tamanos = Array.from(this.querySelectorAll('[data-deseado-tamano]'));
          this.sabores = Array.from(this.querySelectorAll('[data-deseado-sabor]'));
          this.boton = this.querySelector('[data-deseado-agregar]');
          this.botonTexto = this.querySelector('[data-deseado-boton-texto]');
          this.prop = this.querySelector('[data-deseado-prop-latas]');
          this.progreso = this.querySelector('[data-deseado-progreso]');
          this.barra = this.querySelector('[data-deseado-barra]');
          this.totalEl = this.querySelector('[data-deseado-total]');
          this.maxEl = this.querySelector('[data-deseado-max]');
          this.precioEl = this.querySelector('[data-deseado-precio]');
          this.tamanoLabel = this.querySelector('[data-deseado-tamano-label]');
          this.stage = this.querySelector('[data-deseado-stage]');
          this.inicio = this.querySelector('[data-deseado-inicio]');
          this.saboresBox = this.querySelector('[data-deseado-sabores]');
          this.pasos = Array.from(this.querySelectorAll('[data-deseado-paso]'));
          this.precioLabel = '';
          this.caja = this.querySelector('[data-deseado-caja]');
          this.filas = this.querySelector('[data-deseado-filas]');
          this.stageMsg = this.querySelector('[data-deseado-stage-msg]');
          this.resumen = this.querySelector('[data-deseado-resumen]');
          this.errorBox = this.querySelector('[data-deseado-error]');

          this.max = 0;
          // Las latas en el orden en que se eligieron: cada una ocupa un hueco de la caja.
          this.orden = [];

          this.tamanos.forEach((r) => r.addEventListener('change', () => this.elegirTamano(r)));
          this.sabores.forEach((s) => {
            s.querySelector('[data-deseado-mas]').addEventListener('click', () => this.sumar(s, 1));
            s.querySelector('[data-deseado-menos]').addEventListener('click', () => this.sumar(s, -1));
            // Al pasar por un sabor, sus latas se destacan en la caja.
            const resaltar = (on) => this.resaltar(s, on);
            s.addEventListener('mouseenter', () => resaltar(true));
            s.addEventListener('mouseleave', () => resaltar(false));
            s.addEventListener('focusin', () => resaltar(true));
            s.addEventListener('focusout', () => resaltar(false));
          });
          if (this.form) this.form.addEventListener('submit', (e) => this.onSubmit(e));

          const marcado = this.tamanos.find((r) => r.checked);
          if (marcado) this.elegirTamano(marcado);
          this.actualizar();
        }

        get total() { return this.orden.length; }
        cantidad(sabor) { let n = 0; this.orden.forEach((x) => { if (x === sabor) n++; }); return n; }

        elegirTamano(radio) {
          const primeraVez = !this.max;
          this.max = parseInt(radio.dataset.latas, 10) || 0;
          this.precioLabel = radio.dataset.priceLabel || '';
          if (this.tamanoLabel) this.tamanoLabel.textContent = this.max + ' latas · ' + this.precioLabel;
          if (this.precioEl) this.precioEl.textContent = this.precioLabel;
          if (this.progreso) this.progreso.hidden = false;
          if (this.inicio) this.inicio.hidden = true;
          if (this.stage) this.stage.classList.remove('is-inicio');
          if (this.caja) {
            this.caja.classList.remove('is-oculta');
            if (primeraVez) { this.caja.classList.add('is-nueva'); setTimeout(() => this.caja.classList.remove('is-nueva'), 600); }
          }
          if (this.saboresBox) this.saboresBox.classList.remove('is-bloqueado');
          if (this.stageMsg) this.stageMsg.hidden = false;
          // Elegido el tamaño, el paso siguiente son los sabores: los traemos a la vista.
          if (primeraVez || this.total === 0) this.mostrarSabores();
          // Si achicó el pack y ya había más latas que el nuevo máximo, saca las últimas.
          while (this.total > this.max) this.orden.pop();
          this.showError('');
          this.actualizar();
        }

        /* Baja hasta la lista de sabores. Ojo: en Horizon el scroll no es el de la
           ventana sino el de un contenedor (.page-wrapper), así que buscamos el
           ancestro que realmente scrollea antes de mover nada. */
        mostrarSabores() {
          const destino = this.saboresBox;
          if (!destino) return;
          const caja = destino.getBoundingClientRect();
          const alto = window.innerHeight || document.documentElement.clientHeight;
          if (caja.top >= 0 && caja.bottom <= alto) return;   // ya se ve entera
          const suave = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
          let cont = destino.parentElement;
          while (cont && cont !== document.body) {
            const ov = getComputedStyle(cont).overflowY;
            if ((ov === 'auto' || ov === 'scroll') && cont.scrollHeight > cont.clientHeight + 20) break;
            cont = cont.parentElement;
          }
          if (cont && cont !== document.body) {
            const rc = cont.getBoundingClientRect();
            const margen = Math.max(16, (cont.clientHeight - caja.height) / 2);
            cont.scrollTo({ top: cont.scrollTop + (caja.top - rc.top) - margen, behavior: suave });
          } else {
            destino.scrollIntoView({ behavior: suave, block: 'center' });
          }
        }

        sumar(sabor, delta) {
          if (!this.max) { this.showError('Primero elegí el tamaño del pack.'); return; }
          if (delta > 0) {
            if (this.total >= this.max) return;
            this.orden.push(sabor);
          } else {
            const i = this.orden.lastIndexOf(sabor);
            if (i === -1) return;
            this.orden.splice(i, 1);
          }
          this.showError('');
          this.actualizar();
        }

        actualizar() {
          const total = this.total, max = this.max, completo = max > 0 && total === max;
          this.sabores.forEach((s) => {
            const n = this.cantidad(s);
            s.querySelector('[data-deseado-cantidad]').value = n;
            s.classList.toggle('is-elegido', n > 0);
            const agotado = s.classList.contains('is-agotado');
            s.querySelector('[data-deseado-mas]').disabled = agotado || !max || total >= max;
            s.querySelector('[data-deseado-menos]').disabled = agotado || n === 0;
          });
          if (this.totalEl) this.totalEl.textContent = total;
          if (this.maxEl) this.maxEl.textContent = max;
          if (this.barra) this.barra.style.width = max ? (total / max * 100) + '%' : '0%';
          if (this.progreso) this.progreso.classList.toggle('is-completo', completo);

          const partes = [];
          this.sabores.forEach((s) => { const n = this.cantidad(s); if (n > 0) partes.push(n + ' × ' + s.dataset.nombre); });
          if (this.prop) this.prop.value = partes.join(', ');

          this.dibujarCaja(total, max, completo);

          if (this.boton) {
            this.boton.disabled = !completo;
            if (this.botonTexto) this.botonTexto.textContent = !max ? 'Primero elegí el tamaño' : (completo ? ('Agregar mi pack · ' + this.precioLabel) : ('Faltan ' + (max - total) + (max - total === 1 ? ' lata' : ' latas')));
          }
          // pasos: 1 listo al elegir tamaño, 2 listo al completar, 3 actual cuando se puede agregar
          const actual = !max ? 1 : (completo ? 3 : 2);
          this.pasos.forEach((el) => {
            const n = parseInt(el.dataset.deseadoPaso, 10);
            el.classList.toggle('is-listo', n < actual);
            el.classList.toggle('is-actual', n === actual);
          });
        }

        /* ── La caja: un hueco por lata; se llena de adelante hacia atrás, de izquierda a derecha ── */
        dibujarCaja(total, max, completo) {
          if (!this.filas || !this.caja) return;
          if (!max) return;
          const cols = max >= 24 ? 6 : (max >= 12 ? 4 : 3);
          const rows = max >= 24 ? 4 : (max >= 12 ? 3 : 2);
          this.caja.style.setProperty('--cols', cols);
          this.caja.style.setProperty('--rows', rows);
          this.caja.classList.toggle('is-inactiva', !max);
          this.caja.style.setProperty('--sb', Math.pow(0.94, rows - 1).toFixed(3));
          this.caja.style.setProperty('--rise', rows >= 4 ? '0.54' : '0.6');   // con 4 filas la pila sube menos para no hacerse eterna

          // Rearma las filas si cambió el tamaño. En el DOM van de atrás hacia adelante.
          if (this._cols !== cols || this._rows !== rows) {
            this._cols = cols; this._rows = rows;
            this.filas.querySelectorAll('.deseado-pack__fila').forEach((f) => f.remove());
            for (let k = rows - 1; k >= 0; k--) {
              const fila = document.createElement('div');
              fila.className = 'deseado-pack__fila'; fila.style.setProperty('--k', k);
              for (let c = 0; c < cols; c++) {
                const h = document.createElement('div'); h.className = 'deseado-pack__hueco'; h.dataset.handle = ''; fila.appendChild(h);
              }
              this.filas.appendChild(fila);
            }
          }
          const filasDom = Array.from(this.filas.querySelectorAll('.deseado-pack__fila'));
          for (let i = 0; i < cols * rows; i++) {
            const r = Math.floor(i / cols), c = i % cols;         // r = 0 es la fila de adelante
            const hueco = filasDom[rows - 1 - r].children[c];
            const s = this.orden[i] || null;
            const handle = s ? s.dataset.handle : '';
            if (hueco.dataset.handle !== handle) {
              hueco.dataset.handle = handle;
              hueco.innerHTML = '';
              if (s) {
                const img = document.createElement('img');
                img.className = 'deseado-pack__lata'; img.src = s.dataset.lata; img.alt = s.dataset.nombre;
                img.width = 500; img.height = 1000; img.decoding = 'async';
                hueco.appendChild(img);
              }
            }
            hueco.classList.toggle('is-llena', !!s);
            hueco.classList.toggle('is-proxima', !!max && !completo && i === total);
          }

          if (this.resumen) {
            this.resumen.innerHTML = '';
            this.sabores.forEach((s) => {
              const c = this.cantidad(s);
              if (!c) return;
              const li = document.createElement('li');
              li.style.cssText = s.getAttribute('style') || '';
              li.textContent = c + ' × ' + s.dataset.nombre;
              this.resumen.appendChild(li);
            });
          }
          if (this.stageMsg) {
            const faltan = max - total;
            this.stageMsg.textContent = !max ? ''
              : (completo ? '¡Caja completa! Ya podés agregar tu pack.'
              : (total === 0 ? 'Tocá + en los sabores: cada lata cae en su lugar.' : ('Faltan ' + faltan + (faltan === 1 ? ' lata' : ' latas') + ' para completar la caja.')));
          }
        }

        resaltar(sabor, on) {
          if (!this.filas) return;
          this.filas.querySelectorAll('.deseado-pack__hueco').forEach((h) => {
            h.classList.toggle('is-resaltada', on && h.dataset.handle !== '' && h.dataset.handle === sabor.dataset.handle);
          });
        }

        /* ── Agregar al carrito: mismo contrato que la PDP y los quick-add ── */
        loadEvents() {
          if (!this._events) {
            const url = this.dataset.eventsModule;
            this._events = url ? import(url).then((m) => (m && m.CartLinesUpdateEvent ? m : null)).catch(() => null) : Promise.resolve(null);
          }
          return this._events;
        }

        async onSubmit(event) {
          if (!window.fetch || !this.form) return;
          event.preventDefault();
          if (this._busy) return;
          if (!this.max || this.total !== this.max) { this.showError('Completá el pack antes de agregarlo.'); return; }
          this._busy = true; this.boton.setAttribute('aria-busy', 'true'); this.showError('');

          const formData = new FormData(this.form);
          const variantId = formData.get('id');
          formData.set('quantity', '1');
          const sectionIds = [];
          document.querySelectorAll('cart-items-component[data-section-id]').forEach((n) => { const id = n.dataset.sectionId; if (id && sectionIds.indexOf(id) === -1) sectionIds.push(id); });
          if (sectionIds.length) formData.set('sections', sectionIds.join(','));

          const events = await this.loadEvents();
          let deferred = null;
          if (events) {
            deferred = events.CartLinesUpdateEvent.createPromise();
            this.dispatchEvent(new events.CartLinesUpdateEvent({ action: 'add', context: 'product', lines: [{ merchandiseId: variantId, quantity: 1 }], promise: deferred.promise }));
          }
          try {
            const payload = await fetch(this.dataset.cartAddUrl || '/cart/add.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: formData }).then((r) => r.json());
            if (payload.status) throw new Error(payload.description || payload.message || '');
            await this.settle(events, deferred, { itemCount: 1, sections: payload.sections, didError: false });
            this.boton.classList.add('is-added'); setTimeout(() => this.boton.classList.remove('is-added'), 1600);
            if (!events) { const a = window.Shopify && window.Shopify.actions; if (a && a.openCart) a.openCart(); else window.location.href = (this.dataset.cartJsonUrl || '/cart.js').replace(/\.js$/, ''); }
          } catch (error) {
            await this.settle(events, deferred, { itemCount: 1, didError: true });
            this.showError((error && error.message) || 'No pudimos agregar el pack. Probá de nuevo.');
          } finally {
            this._busy = false; this.boton.setAttribute('aria-busy', 'false');
          }
        }

        async settle(events, deferred, detail) {
          if (!events || !deferred) return;
          try {
            const cart = await fetch(this.dataset.cartJsonUrl || '/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
            deferred.resolve({ cart: events.CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: Object.assign({ items: cart.items, source: 'deseado-creatupack', sourceId: this.id || 'deseado-creatupack' }, detail) });
          } catch (error) { deferred.reject(error); }
        }

        showError(msg) { if (!this.errorBox) return; this.errorBox.textContent = msg || ''; this.errorBox.hidden = !msg; }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["deseado-hero"] && !Shopify.designMode) return;
  try {
    
  // Control de pausa del video del hero. Autocontenido, sin dependencias.
  if (!customElements.get('deseado-hero')) {
    customElements.define(
      'deseado-hero',
      class DeseadoHero extends HTMLElement {
        connectedCallback() {
          if (this._wired) return;
          this._wired = true;

          this.video = this.querySelector('[data-deseado-video]');
          this.boton = this.querySelector('[data-deseado-pausa]');
          if (!this.video || !this.boton) return;

          // El botón aparece recién ahora: sin JS no haría nada.
          this.boton.hidden = false;

          // Quien pidió menos movimiento no debería recibir un video que
          // arranca solo. Se queda el poster y el botón pasa a "reproducir".
          if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            this.video.removeAttribute('autoplay');
            this.video.pause();
          }

          this.boton.addEventListener('click', () => this.alternar());
          this.video.addEventListener('play', () => this.reflejar());
          this.video.addEventListener('pause', () => this.reflejar());
          this.reflejar();
        }

        alternar() {
          if (this.video.paused) {
            // play() devuelve una promesa que puede rechazarse (por ejemplo si
            // el navegador bloquea la reproducción). Sin catch queda un error
            // sin manejar en la consola.
            const p = this.video.play();
            if (p && p.catch) p.catch(() => {});
          } else {
            this.video.pause();
          }
        }

        reflejar() {
          const pausado = this.video.paused;
          this.boton.classList.toggle('esta-pausado', pausado);
          this.boton.setAttribute('aria-label', pausado ? 'Reproducir el video' : 'Pausar el video');
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["deseado-historia"] && !Shopify.designMode) return;
  try {
    
  // Línea de tiempo. Autocontenida, sin dependencias del tema.
  if (!customElements.get('deseado-historia')) {
    customElements.define(
      'deseado-historia',
      class DeseadoHistoria extends HTMLElement {
        connectedCallback() {
          if (this._wired) return;
          this._wired = true;

          this.riel = this.querySelector('[data-deseado-riel]');
          this.hitos = Array.from(this.querySelectorAll('[data-deseado-hito]'));
          this.marcadores = Array.from(this.querySelectorAll('[data-deseado-marcador]'));
          this.avance = this.querySelector('[data-deseado-avance]');
          if (!this.riel || this.hitos.length < 2) return;

          // El eje se revela recién ahora: si el JS no llegaba, no aparecía un
          // control que no hace nada.
          const eje = this.querySelector('[data-deseado-eje]');
          if (eje) {
            eje.hidden = false;
            // Las posiciones de la línea dependen de cuántos hitos hay.
            eje.style.setProperty('--hitos', String(this.hitos.length));
          }

          this.marcadores.forEach((marcador) => {
            marcador.addEventListener('click', () => {
              this.irA(parseInt(marcador.dataset.indice, 10) || 0);
            });
            marcador.addEventListener('keydown', (evento) => this.onKeydown(evento, marcador));
          });

          this.riel.addEventListener('scroll', () => this.programarActualizacion(), { passive: true });
          ['wheel', 'touchstart', 'pointerdown'].forEach((evento) => {
            this.riel.addEventListener(evento, () => { this._fijado = null; }, { passive: true });
          });
          this.riel.addEventListener('keydown', () => { this._fijado = null; });
          this._fijado = null;
          this.actualizar();
        }

        disconnectedCallback() {
          if (this._raf) cancelAnimationFrame(this._raf);
        }

        // Flechas para moverse entre marcadores, como en cualquier serie de
        // controles relacionados.
        onKeydown(evento, marcador) {
          const indice = parseInt(marcador.dataset.indice, 10) || 0;
          const ultimo = this.marcadores.length - 1;
          let destino = null;

          if (evento.key === 'ArrowRight') destino = Math.min(ultimo, indice + 1);
          else if (evento.key === 'ArrowLeft') destino = Math.max(0, indice - 1);
          else if (evento.key === 'Home') destino = 0;
          else if (evento.key === 'End') destino = ultimo;

          if (destino === null) return;
          evento.preventDefault();
          this.irA(destino);
          if (this.marcadores[destino]) this.marcadores[destino].focus();
        }

        // Progreso del scroll, de 0 (inicio) a 1 (final). Es lo que mueve el
        // eje. Antes se marcaba "actual" a la tarjeta pegada al borde
        // izquierdo, pero en desktop entran cuatro: al llegar al final la del
        // borde es la quinta, no la última, y el eje nunca llegaba a 2026.
        get progreso() {
          const max = this.riel.scrollWidth - this.riel.clientWidth;
          if (max <= 0) return 0;
          return Math.min(1, Math.max(0, this.riel.scrollLeft / max));
        }

        // Al hacer clic en un año, ESE año queda marcado aunque su tarjeta no
        // pueda pegarse al borde (las últimas nunca pueden). El marcado fijo se
        // suelta recién cuando el usuario vuelve a mover el riel por su cuenta.
        irA(indice) {
          const destino = Math.max(0, Math.min(this.hitos.length - 1, indice));
          const hito = this.hitos[destino];
          if (!hito) return;
          this._fijado = destino;
          this.actualizar();
          // Con rects, no con offsetLeft: el ancestro posicionado del riel y el
          // de las tarjetas no es el mismo y la resta daba cualquier cosa.
          const delta = hito.getBoundingClientRect().left - this.riel.getBoundingClientRect().left;
          this.riel.scrollTo({
            left: this.riel.scrollLeft + delta,
            behavior: this.reducirMovimiento ? 'auto' : 'smooth',
          });
        }

        get reducirMovimiento() {
          return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        }

        programarActualizacion() {
          if (this._raf) cancelAnimationFrame(this._raf);
          this._raf = requestAnimationFrame(() => this.actualizar());
        }

        actualizar() {
          const n = this.hitos.length;
          let indice;
          let avance;
          if (this._fijado !== null && this._fijado !== undefined) {
            indice = this._fijado;
            avance = n > 1 ? indice / (n - 1) : 0;
          } else {
            avance = this.progreso;
            indice = Math.round(avance * (n - 1));
          }

          this.hitos.forEach((h, i) => h.classList.toggle('is-actual', i === indice));
          this.marcadores.forEach((m, i) => {
            m.setAttribute('aria-current', i === indice ? 'true' : 'false');
          });
          // La barra amarilla sigue al scroll de forma continua, así llega al
          // 100% exacto al final aunque el marcador vaya de a saltos.
          if (this.avance) this.avance.style.width = (avance * 100) + '%';
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["deseado-pack-mayorista"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('deseado-pack-mayorista')) {
    customElements.define(
      'deseado-pack-mayorista',
      class extends HTMLElement {
        connectedCallback() {
          if (this._wired) return;
          this._wired = true;
          this.form = this.querySelector('form[action*="/cart/add"]');
          this.tamanos = Array.from(this.querySelectorAll('[data-deseado-tamano]'));
          this.sabores = Array.from(this.querySelectorAll('[data-deseado-sabor]'));
          this.boton = this.querySelector('[data-deseado-agregar]');
          this.botonTexto = this.querySelector('[data-deseado-boton-texto]');
          this.propUnidades = this.querySelector('[data-deseado-prop-unidades]');
          this.propLatas = this.querySelector('[data-deseado-prop-latas]');
          this.progreso = this.querySelector('.deseado-pmay__progreso');
          this.barra = this.querySelector('[data-deseado-barra]');
          this.totalEl = this.querySelector('[data-deseado-total]');
          this.maxEl = this.querySelector('[data-deseado-max]');
          this.latasEl = this.querySelector('[data-deseado-latas]');
          this.precioEl = this.querySelector('[data-deseado-precio]');
          this.resumen = this.querySelector('[data-deseado-resumen]');
          this.errorBox = this.querySelector('[data-deseado-error]');
          this.porUnidad = parseInt(this.dataset.porUnidad, 10) || 6;
          this.unidad = this.dataset.unidad || 'six-pack';
          this.unidadPlural = this.dataset.unidadPlural || 'six-packs';
          this.max = 0; this.precioLabel = '';
          this.cantidades = new Map();

          this.tamanos.forEach((r) => r.addEventListener('change', () => this.elegirTamano(r)));
          this.sabores.forEach((s) => {
            this.cantidades.set(s, 0);
            s.querySelector('[data-deseado-mas]').addEventListener('click', () => this.sumar(s, 1));
            s.querySelector('[data-deseado-menos]').addEventListener('click', () => this.sumar(s, -1));
          });
          if (this.form) this.form.addEventListener('submit', (e) => this.onSubmit(e));

          const marcado = this.tamanos.find((r) => r.checked && !r.disabled) || this.tamanos.find((r) => !r.disabled);
          if (marcado) { marcado.checked = true; this.elegirTamano(marcado); } else this.render();
        }

        get total() { let t = 0; this.cantidades.forEach((c) => { t += c; }); return t; }

        elegirTamano(radio) {
          const latas = parseInt(radio.dataset.latas, 10) || 0;
          this.max = Math.floor(latas / this.porUnidad);
          this.precioLabel = radio.dataset.priceLabel || '';
          if (this.precioEl) this.precioEl.textContent = this.precioLabel;
          // si el tamaño nuevo es más chico, recorta desde el final
          while (this.total > this.max) {
            const ultimo = this.sabores.slice().reverse().find((s) => this.cantidades.get(s) > 0);
            if (!ultimo) break;
            this.cantidades.set(ultimo, this.cantidades.get(ultimo) - 1);
          }
          this.render();
        }

        sumar(sabor, delta) {
          const actual = this.cantidades.get(sabor) || 0;
          const nuevo = actual + delta;
          if (nuevo < 0) return;
          if (delta > 0 && this.total >= this.max) return;
          this.cantidades.set(sabor, nuevo);
          this.showError('');
          this.render();
        }

        render() {
          const total = this.total, max = this.max, completo = max > 0 && total === max;
          const lleno = total >= max;
          this.sabores.forEach((s) => {
            const c = this.cantidades.get(s) || 0;
            s.querySelector('[data-deseado-cantidad]').textContent = c;
            s.querySelector('[data-deseado-menos]').disabled = c === 0;
            s.querySelector('[data-deseado-mas]').disabled = lleno || s.classList.contains('is-agotado');
            const l = s.querySelector('[data-deseado-sabor-latas]');
            if (l) l.textContent = c ? (c * this.porUnidad) + ' latas' : '';
          });
          if (this.totalEl) this.totalEl.textContent = total;
          if (this.maxEl) this.maxEl.textContent = max;
          if (this.latasEl) this.latasEl.textContent = total * this.porUnidad;
          if (this.barra) this.barra.style.width = (max ? Math.round((total / max) * 100) : 0) + '%';
          if (this.progreso) this.progreso.classList.toggle('is-completo', completo);

          const partes = [], latas = [];
          this.sabores.forEach((s) => {
            const c = this.cantidades.get(s) || 0;
            if (!c) return;
            partes.push(c + ' × ' + s.dataset.nombre);
            latas.push((c * this.porUnidad) + ' × ' + s.dataset.nombre);
          });
          if (this.propUnidades) this.propUnidades.value = partes.join(', ');
          if (this.propLatas) this.propLatas.value = latas.join(', ');
          if (this.resumen) {
            this.resumen.innerHTML = '';
            this.sabores.forEach((s) => {
              const c = this.cantidades.get(s) || 0;
              if (!c) return;
              const li = document.createElement('li');
              li.style.cssText = s.getAttribute('style') || '';
              li.textContent = c + ' × ' + s.dataset.nombre + ' (' + (c * this.porUnidad) + ' latas)';
              this.resumen.appendChild(li);
            });
          }
          if (this.boton) {
            this.boton.disabled = !completo;
            const faltan = max - total;
            if (this.botonTexto) this.botonTexto.textContent = !max ? 'Sin stock'
              : (completo ? ('Agregar pack · ' + this.precioLabel)
              : ('Faltan ' + faltan + ' ' + (faltan === 1 ? this.unidad : this.unidadPlural)));
          }
        }

        /* ── Agregar al carrito: mismo contrato que la PDP, el armador y los quick-add ── */
        loadEvents() {
          if (!this._events) {
            const url = this.dataset.eventsModule;
            this._events = url ? import(url).then((m) => (m && m.CartLinesUpdateEvent ? m : null)).catch(() => null) : Promise.resolve(null);
          }
          return this._events;
        }

        async onSubmit(event) {
          if (!window.fetch || !this.form) return;
          event.preventDefault();
          if (this._busy) return;
          if (!this.max || this.total !== this.max) { this.showError('Repartí los ' + this.max + ' ' + this.unidadPlural + ' antes de agregar el pack.'); return; }
          this._busy = true; this.boton.setAttribute('aria-busy', 'true'); this.showError('');

          const formData = new FormData(this.form);
          const variantId = formData.get('id');
          formData.set('quantity', '1');
          const sectionIds = [];
          document.querySelectorAll('cart-items-component[data-section-id]').forEach((n) => { const id = n.dataset.sectionId; if (id && sectionIds.indexOf(id) === -1) sectionIds.push(id); });
          if (sectionIds.length) formData.set('sections', sectionIds.join(','));

          const events = await this.loadEvents();
          let deferred = null;
          if (events) {
            deferred = events.CartLinesUpdateEvent.createPromise();
            this.dispatchEvent(new events.CartLinesUpdateEvent({ action: 'add', context: 'product', lines: [{ merchandiseId: variantId, quantity: 1 }], promise: deferred.promise }));
          }
          try {
            const payload = await fetch(this.dataset.cartAddUrl || '/cart/add.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: formData }).then((r) => r.json());
            if (payload.status) throw new Error(payload.description || payload.message || '');
            await this.settle(events, deferred, { itemCount: 1, sections: payload.sections, didError: false });
            this.boton.classList.add('is-added'); setTimeout(() => this.boton.classList.remove('is-added'), 1600);
            if (!events) { const a = window.Shopify && window.Shopify.actions; if (a && a.openCart) a.openCart(); else window.location.href = (this.dataset.cartJsonUrl || '/cart.js').replace(/\.js$/, ''); }
          } catch (error) {
            await this.settle(events, deferred, { itemCount: 1, didError: true });
            this.showError((error && error.message) || 'No pudimos agregar el pack. Probá de nuevo.');
          } finally {
            this._busy = false; this.boton.setAttribute('aria-busy', 'false');
          }
        }

        async settle(events, deferred, detail) {
          if (!events || !deferred) return;
          try {
            const cart = await fetch(this.dataset.cartJsonUrl || '/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
            deferred.resolve({ cart: events.CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: Object.assign({ items: cart.items, source: 'deseado-pack-mayorista', sourceId: this.id || 'deseado-pack-mayorista' }, detail) });
          } catch (error) { deferred.reject(error); }
        }

        showError(msg) { if (!this.errorBox) return; this.errorBox.textContent = msg || ''; this.errorBox.hidden = !msg; }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["deseado-pdp"] && !Shopify.designMode) return;
  try {
    
  // Custom element autocontenido para la PDP de DESEADO.
  // Se auto-inicializa al insertarse en el DOM (también en el editor de temas).
  //
  // Ojo: este bloque NO procesa Liquid. Todo lo que viene del servidor (rutas,
  // formato de moneda, URLs de módulos) llega por data attributes en <deseado-pdp>.
  if (!customElements.get('deseado-pdp')) {
    customElements.define(
      'deseado-pdp',
      class DeseadoPdp extends HTMLElement {
        connectedCallback() {
          if (this._wired) return;
          this._wired = true;

          this.mainImage = this.querySelector('[data-deseado-main-image]');
          this.qtyInput = this.querySelector('[data-deseado-qty]');
          this.form = this.querySelector('form[action*="/cart/add"]');
          this.addButton = this.querySelector('[data-deseado-add]');
          this.errorBox = this.querySelector('[data-deseado-error]');
          this.stickyBar = this.querySelector('[data-deseado-sticky]');
          this.stickyImage = this.querySelector('[data-deseado-sticky-image]');
          this.stickySize = this.querySelector('[data-deseado-sticky-size]');

          // Hay dos rótulos de precio: el del botón y el de la barra sticky.
          this.priceLabels = Array.from(this.querySelectorAll('[data-deseado-price-label]'));

          // Rótulo del precio grande y su "Desde".
          this.priceMain = this.querySelector('[data-deseado-price-main]');
          this.priceFrom = this.querySelector('[data-deseado-price-from]');

          // Foto general del producto: es a la que volvemos si el tamaño elegido
          // no tiene una foto propia asignada en el admin.
          this.defaultImage = this.mainImage ? this.mainImage.src : '';
          this.defaultStickyImage = this.stickyImage ? this.stickyImage.src : '';

          // Tamaño → precio, imagen y URL. La variante que se agrega la define el
          // propio radio (name="id"), no el JS.
          this.sizes = Array.from(this.querySelectorAll('[data-deseado-size]'));
          this.sizes.forEach((radio) => {
            radio.addEventListener('change', () => this.onSizeChange(radio));
          });

          // Cantidad − / +
          const dec = this.querySelector('[data-deseado-qty-dec]');
          const inc = this.querySelector('[data-deseado-qty-inc]');
          if (dec) dec.addEventListener('click', () => this.stepQty(-1));
          if (inc) inc.addEventListener('click', () => this.stepQty(1));
          if (this.qtyInput) {
            this.qtyInput.addEventListener('input', () => this.refreshPrice());
            this.qtyInput.addEventListener('change', () => this.refreshPrice());
          }

          if (this.form) {
            this.form.addEventListener('submit', (event) => this.onSubmit(event));
          }

          // Sin tamaño elegido no se agrega nada. El atributo required ya lo frena
          // a nivel navegador (y sigue siendo la red de seguridad si el JS no
          // carga), pero su mensaje viene en inglés y apunta a un radio que está
          // visualmente oculto, así que acá lo atajamos antes con uno propio.
          this.sizesFieldset = this.querySelector('.deseado-pdp__sizes');
          if (this.addButton) {
            this.addButton.addEventListener('click', (event) => {
              if (!this.ensureSize()) event.preventDefault();
            });
          }

          const stickyAdd = this.querySelector('[data-deseado-sticky-add]');
          if (stickyAdd && this.form) {
            stickyAdd.addEventListener('click', () => {
              if (!this.ensureSize()) return;
              // requestSubmit dispara el evento submit (y con él, el AJAX).
              // submit() a secas no lo dispara: queda como POST normal, que igual
              // agrega al carrito.
              if (this.form.requestSubmit) this.form.requestSubmit();
              else this.form.submit();
            });
          }

          this.medirHeader();
          window.addEventListener('resize', () => this.medirHeader());
          this.setupStickyBar();
          this.refreshPrice();
        }

        disconnectedCallback() {
          if (this._stickyObserver) this._stickyObserver.disconnect();
          if (this._addedTimeout) clearTimeout(this._addedTimeout);
        }

        /* ────────────────────────── Lecturas ────────────────────────── */

        get selectedSize() {
          return this.sizes.find((radio) => radio.checked) || null;
        }

        // true si hay tamaño elegido. Si no, avisa y lleva al selector.
        ensureSize() {
          if (this.selectedSize) return true;

          this.showError('Elegí un tamaño para agregar al carrito.');

          if (this.sizesFieldset) {
            this.sizesFieldset.classList.add('is-missing');
            this.sizesFieldset.scrollIntoView({ block: 'center', behavior: 'smooth' });
            const first = this.sizes.find((radio) => !radio.disabled);
            if (first) first.focus();
          }
          return false;
        }

        get quantity() {
          const min = parseInt(this.qtyInput && this.qtyInput.min, 10) || 1;
          const value = parseInt(this.qtyInput && this.qtyInput.value, 10);
          if (isNaN(value) || value < min) return min;
          return value;
        }

        /* ─────────────────────────── Precio ─────────────────────────── */

        // Carga perezosa del formateador de moneda del propio tema, para no
        // reimplementar el filtro | money a mano.
        loadMoneyFormatter() {
          if (!this._money) {
            const url = this.dataset.moneyModule;
            this._money = url
              ? import(url)
                  .then((module) => module.formatMoney)
                  .catch(() => null)
              : Promise.resolve(null);
          }
          return this._money;
        }

        // El botón muestra el total de la línea: precio de la variante × cantidad.
        refreshPrice() {
          const radio = this.selectedSize;
          if (!radio) return;

          const fallback = radio.getAttribute('data-price-label') || '';
          const cents = parseInt(radio.getAttribute('data-price-cents'), 10);
          const quantity = this.quantity;

          if (isNaN(cents)) {
            this.setPriceLabels(fallback);
            return;
          }

          this.loadMoneyFormatter().then((formatMoney) => {
            // Si el módulo no cargó, mejor el precio unitario bien formateado que
            // un total mal formateado.
            if (!formatMoney) {
              this.setPriceLabels(fallback);
              return;
            }
            // Sin formato de moneda no hay con qué armar el total: mostramos el
            // precio unitario que ya vino formateado por el filtro | money.
            const format = this.dataset.moneyFormat;
            if (!format) {
              this.setPriceLabels(fallback);
              return;
            }
            this.setPriceLabels(formatMoney(cents * quantity, format, this.dataset.currency || ''));
          });
        }

        setPriceLabels(text) {
          this.priceLabels.forEach((label) => {
            label.textContent = text;
          });
        }

        /* ────────────────────── Galería y variantes ─────────────────── */

        onSizeChange(radio) {
          this.refreshPrice();

          // Ya eligió: se va el aviso.
          this.showError('');
          if (this.sizesFieldset) this.sizesFieldset.classList.remove('is-missing');

          if (this.stickySize) {
            this.stickySize.textContent = radio.getAttribute('data-size-label') || '';
          }

          // Precio grande: pasa a ser el de este pack, y se va el "Desde".
          if (this.priceMain) {
            this.priceMain.textContent = radio.getAttribute('data-price-label') || '';
          }
          if (this.priceFrom) this.priceFrom.hidden = true;

          // La URL refleja la variante elegida, así el link se puede compartir.
          const variantUrl = radio.getAttribute('data-variant-url');
          if (variantUrl && window.history && window.history.replaceState) {
            window.history.replaceState({}, '', variantUrl);
          }

          // Foto del tamaño elegido. Si ese tamaño no tiene foto propia cargada
          // en el admin, volvemos a la general del producto: dejar la del tamaño
          // anterior sería mostrar algo que no es lo que se está comprando.
          const full = radio.getAttribute('data-variant-image') || this.defaultImage;
          const small =
            radio.getAttribute('data-variant-image-small') ||
            radio.getAttribute('data-variant-image') ||
            this.defaultStickyImage;

          if (this.mainImage && full) this.mainImage.src = full;
          if (this.stickyImage && small) this.stickyImage.src = small;
        }

        stepQty(direction) {
          if (!this.qtyInput) return;
          const min = parseInt(this.qtyInput.min, 10) || 1;
          let value = parseInt(this.qtyInput.value, 10);
          if (isNaN(value)) value = min;
          value += direction;
          if (value < min) value = min;
          this.qtyInput.value = value;
          this.qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        /* ──────────────────────── Barra sticky ──────────────────────── */

        // Altura del header cuando está pegado, para colgar la barra debajo.
        medirHeader() {
          // El header pegado de Horizon es el propio <header> del grupo de header.
          const header = document.querySelector('header.shopify-section-group-header-group, header-component, [id*="header_section"]');
          const pegado = header && /sticky|fixed/.test(getComputedStyle(header).position);
          const h = header && pegado ? header.getBoundingClientRect().height : 0;
          this.style.setProperty('--deseado-header-h', Math.round(h) + 'px');
        }

        // Aparece solo cuando el bloque de compra ya pasó hacia arriba, no cuando
        // todavía no llegamos a él.
        setupStickyBar() {
          const buyBlock = this.querySelector('[data-deseado-buy]');
          if (!this.stickyBar || !buyBlock || !('IntersectionObserver' in window)) return;

          const observer = new IntersectionObserver(
            (entries) => {
              const entry = entries[0];
              if (!entry) return;
              const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
              this.stickyBar.hidden = !scrolledPast;
            },
            { threshold: 0 }
          );
          observer.observe(buyBlock);
          this._stickyObserver = observer;
        }

        /* ───────────────────── Agregar al carrito ───────────────────── */

        // Agrega por AJAX y deja que el cart drawer de Horizon se refresque y se
        // abra solo. Horizon escucha el evento estándar cartLinesUpdate, así que
        // usamos exactamente ese contrato en vez de tocar sus internals.
        async onSubmit(event) {
          if (!window.fetch || !this.form) return; // sin fetch: POST normal

          event.preventDefault();
          if (this._busy) return;

          this.setBusy(true);
          this.showError('');

          const formData = new FormData(this.form);
          const quantity = this.quantity;
          const variantId = formData.get('id');
          formData.set('quantity', String(quantity));

          // Le pedimos a Shopify las secciones del carrito ya renderizadas, así el
          // drawer se actualiza sin un segundo viaje.
          const sectionIds = [];
          document.querySelectorAll('cart-items-component[data-section-id]').forEach((node) => {
            const id = node.dataset.sectionId;
            if (id && sectionIds.indexOf(id) === -1) sectionIds.push(id);
          });
          if (sectionIds.length) formData.set('sections', sectionIds.join(','));

          const events = await this.loadEvents();
          let deferred = null;

          if (events) {
            deferred = events.CartLinesUpdateEvent.createPromise();
            this.dispatchEvent(
              new events.CartLinesUpdateEvent({
                action: 'add',
                context: 'product',
                lines: [{ merchandiseId: variantId, quantity: quantity }],
                promise: deferred.promise,
              })
            );
          }

          try {
            const response = await fetch(this.dataset.cartAddUrl || '/cart/add.js', {
              method: 'POST',
              headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
              body: formData,
            });
            const payload = await response.json();

            // La API de carrito responde 4xx con { status, message, description }.
            if (payload.status) {
              throw new Error(payload.description || payload.message || '');
            }

            await this.settle(events, deferred, {
              itemCount: quantity,
              sections: payload.sections,
              didError: false,
            });
            this.flashAdded();

            // Sin el módulo de eventos no hay quien abra el drawer: lo pedimos por
            // la API de acciones estándar y, si tampoco está, vamos al carrito.
            if (!events) {
              const actions = window.Shopify && window.Shopify.actions;
              if (actions && actions.openCart) actions.openCart();
              else window.location.href = (this.dataset.cartJsonUrl || '/cart.js').replace(/\.js$/, '');
            }
          } catch (error) {
            await this.settle(events, deferred, { itemCount: quantity, didError: true });
            const message = error && error.message ? error.message : '';
            this.showError(message || 'No pudimos agregarlo al carrito. Probá de nuevo.');
          } finally {
            this.setBusy(false);
          }
        }

        // El módulo de eventos estándar de Shopify, el mismo del importmap del tema.
        loadEvents() {
          if (!this._events) {
            const url = this.dataset.eventsModule;
            this._events = url
              ? import(url)
                  .then((module) => (module && module.CartLinesUpdateEvent ? module : null))
                  .catch(() => null)
              : Promise.resolve(null);
          }
          return this._events;
        }

        // Resolvemos la promesa del evento con el carrito ya actualizado: de ahí
        // sacan su estado el drawer, el contador del header y el resto del tema.
        async settle(events, deferred, detail) {
          if (!events || !deferred) return;
          try {
            const cart = await fetch(this.dataset.cartJsonUrl || '/cart.js', {
              headers: { Accept: 'application/json' },
            }).then((response) => response.json());

            deferred.resolve({
              cart: events.CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
              detail: Object.assign(
                {
                  items: cart.items,
                  source: 'deseado-pdp',
                  sourceId: this.id || 'deseado-pdp',
                },
                detail
              ),
            });
          } catch (error) {
            deferred.reject(error);
          }
        }

        /* ─────────────────────── Estado del botón ───────────────────── */

        setBusy(busy) {
          this._busy = busy;
          if (!this.addButton) return;
          this.addButton.disabled = busy;
          this.addButton.setAttribute('aria-busy', busy ? 'true' : 'false');
        }

        showError(message) {
          if (!this.errorBox) return;
          this.errorBox.textContent = message || '';
          this.errorBox.hidden = !message;
        }

        // Confirmación breve en el botón; el drawer se abre solo por su cuenta.
        flashAdded() {
          if (!this.addButton) return;
          this.addButton.classList.add('is-added');
          if (this._addedTimeout) clearTimeout(this._addedTimeout);
          this._addedTimeout = setTimeout(() => {
            this.addButton.classList.remove('is-added');
          }, 1600);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["deseado-popup"] && !Shopify.designMode) return;
  try {
    
  // Popup de suscripción. Autocontenido, sin dependencias del tema.
  if (!customElements.get('deseado-popup')) {
    customElements.define(
      'deseado-popup',
      class DeseadoPopup extends HTMLElement {
        connectedCallback() {
          if (this._wired) return;
          this._wired = true;

          this.dialog = this.querySelector('dialog');
          if (!this.dialog || typeof this.dialog.showModal !== 'function') return;

          this.clave = this.dataset.clave || 'deseado-popup';
          this.enEditor = this.hasAttribute('data-editor');

          const cerrar = this.querySelector('[data-deseado-cerrar]');
          if (cerrar) cerrar.addEventListener('click', () => this.cerrar('cerrado'));
          // Esc → el navegador dispara 'cancel' y luego 'close'.
          this.dialog.addEventListener('close', () => this.recordar('cerrado'));
          // Clic en el fondo oscuro cierra.
          this.dialog.addEventListener('click', (evento) => {
            if (evento.target === this.dialog) this.cerrar('cerrado');
          });

          // Volvió de un envío exitoso: mostramos el código y no volvemos a
          // aparecer por un año.
          if (this.querySelector('[data-deseado-suscripto]')) {
            this.recordar('suscripto');
            this.abrir();
            return;
          }
          // Volvió con error de validación: lo mostramos para que lo vea.
          if (this.querySelector('.deseado-popup__error')) {
            this.abrir();
            return;
          }

          if (this.enEditor) {
            this.abrir();
            return;
          }

          if (!this.corresponde()) return;
          const segundos = parseInt(this.dataset.delay, 10);
          setTimeout(() => this.abrir(), (isNaN(segundos) ? 5 : segundos) * 1000);
        }

        corresponde() {
          const ruta = location.pathname;
          // Solo en el home, si así está configurado (lo decide Liquid con template.name).
          if (this.dataset.soloHome === 'true' && this.dataset.esHome !== 'true') return false;
          if (/\/(cart|checkout|password|challenge)/.test(ruta)) return false;
          if (new URLSearchParams(location.search).has('sin-popup')) return false;
          try {
            const guardado = localStorage.getItem(this.clave);
            if (guardado) {
              const { hasta } = JSON.parse(guardado);
              if (Date.now() < hasta) return false;
            }
            // Una sola vez por visita, aunque cambie de página.
            if (sessionStorage.getItem(this.clave + ':visto')) return false;
          } catch (e) {
            // Sin storage (modo privado estricto): mostramos igual, una vez.
          }
          return true;
        }

        abrir() {
          if (this.dialog.open) return;
          this.dialog.showModal();
          try { sessionStorage.setItem(this.clave + ':visto', '1'); } catch (e) {}
        }

        cerrar(motivo) {
          if (this.dialog.open) this.dialog.close();
          this.recordar(motivo);
        }

        // Guarda hasta cuándo no volver a mostrarlo. En el editor no guarda
        // nada, para poder abrirlo y cerrarlo mientras se diseña.
        recordar(motivo) {
          if (this.enEditor) return;
          const dias = motivo === 'suscripto' ? 365 : (parseInt(this.dataset.diasCerrado, 10) || 7);
          try {
            localStorage.setItem(this.clave, JSON.stringify({ motivo, hasta: Date.now() + dias * 86400000 }));
          } catch (e) {}
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["deseado-prensa"] && !Shopify.designMode) return;
  try {
    
  // Tablist de prensa. Autocontenido, sin dependencias del tema.
  if (!customElements.get('deseado-prensa')) {
    customElements.define(
      'deseado-prensa',
      class DeseadoPrensa extends HTMLElement {
        connectedCallback() {
          if (this._wired) return;
          this._wired = true;

          this.tabs = Array.from(this.querySelectorAll('[data-deseado-tab]'));
          this.panels = Array.from(this.querySelectorAll('[data-deseado-panel]'));
          if (this.tabs.length < 2) return;

          this.tabs.forEach((tab, index) => {
            tab.addEventListener('click', () => this.select(index));
            tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
          });
        }

        select(index, moverFoco) {
          this.tabs.forEach((tab, i) => {
            const activo = i === index;
            tab.setAttribute('aria-selected', activo ? 'true' : 'false');
            // Un solo tab entra por Tab; entre ellos se navega con las flechas,
            // que es el patrón estándar de tablist.
            tab.tabIndex = activo ? 0 : -1;
            if (this.panels[i]) this.panels[i].classList.toggle('is-active', activo);
          });
          if (moverFoco && this.tabs[index]) this.tabs[index].focus();
        }

        onKeydown(event, index) {
          const ultimo = this.tabs.length - 1;
          let destino = null;

          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') destino = index === ultimo ? 0 : index + 1;
          else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') destino = index === 0 ? ultimo : index - 1;
          else if (event.key === 'Home') destino = 0;
          else if (event.key === 'End') destino = ultimo;

          if (destino === null) return;
          event.preventDefault();
          this.select(destino, true);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["deseado-sabores"] && !Shopify.designMode) return;
  try {
    
  // Sabores: flechas del carrusel y agregado rápido al carrito.
  if (!customElements.get('deseado-sabores')) {
    customElements.define(
      'deseado-sabores',
      class DeseadoSabores extends HTMLElement {
        connectedCallback() {
          if (this._wired) return;
          this._wired = true;

          this.tabs = Array.from(this.querySelectorAll('[data-deseado-tab]'));
          this.paneles = Array.from(this.querySelectorAll('[data-deseado-panel]'));
          if (!this.paneles.length) return;
          // Cada panel tiene su tira y sus flechas; los botones se revelan recién ahora (sin JS no harían nada).
          this.paneles.forEach((panel) => {
            const riel = panel.querySelector('[data-deseado-riel]');
            if (riel) riel.addEventListener('scroll', () => this.programarFlechas(), { passive: true });
            const prev = panel.querySelector('[data-deseado-prev]'), next = panel.querySelector('[data-deseado-next]');
            if (prev) prev.addEventListener('click', () => this.mover(-1));
            if (next) next.addEventListener('click', () => this.mover(1));
          });
          this.querySelectorAll('[data-deseado-agregar]').forEach((boton) => {
            boton.hidden = false;
            boton.addEventListener('click', () => this.agregar(boton));
          });
          this.tabs.forEach((tab, i) => {
            tab.addEventListener('click', () => this.activar(i));
            tab.addEventListener('keydown', (e) => {
              if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
              e.preventDefault();
              const j = (i + (e.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length;
              this.activar(j); this.tabs[j].focus();
            });
          });
          window.addEventListener('resize', () => this.programarFlechas());
          this.activar(0);
        }
        /* ── Pestañas: muestra un panel y apunta el carrusel a su tira ── */
        activar(i) {
          this.paneles.forEach((panel, j) => { panel.hidden = j !== i; });
          this.tabs.forEach((tab, j) => { tab.setAttribute('aria-selected', j === i ? 'true' : 'false'); tab.tabIndex = j === i ? 0 : -1; });
          const panel = this.paneles[i];
          this.riel = panel.querySelector('[data-deseado-riel]');
          this.items = Array.from(panel.querySelectorAll('[data-deseado-item]'));
          this.prev = panel.querySelector('[data-deseado-prev]');
          this.next = panel.querySelector('[data-deseado-next]');
          const conFlechas = this.items.length > 1;
          if (this.prev) this.prev.hidden = !conFlechas;
          if (this.next) this.next.hidden = !conFlechas;
          this.actualizarFlechas();
        }

        disconnectedCallback() {
          if (this._raf) cancelAnimationFrame(this._raf);
        }

        /* ── Carrusel ── */

        get reducirMovimiento() {
          return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        }

        // Avanza de a una pantalla de latas, no de a una lata.
        mover(direccion) {
          if (!this.riel) return;
          const paso = this.riel.clientWidth * 0.9;
          this.riel.scrollBy({ left: paso * direccion, behavior: this.reducirMovimiento ? 'auto' : 'smooth' });
        }

        programarFlechas() {
          if (this._raf) cancelAnimationFrame(this._raf);
          this._raf = requestAnimationFrame(() => this.actualizarFlechas());
        }

        actualizarFlechas() {
          if (!this.riel || !this.prev || !this.next) return;
          const max = this.riel.scrollWidth - this.riel.clientWidth;
          this.prev.disabled = this.riel.scrollLeft <= 2;
          this.next.disabled = this.riel.scrollLeft >= max - 2;
        }

        /* ── Agregado rápido ──
           Mismo contrato que el botón de compra de la PDP: POST al carrito y
           evento estándar de Shopify, así el drawer se refresca y se abre. */

        loadEvents() {
          if (!this._events) {
            const url = this.dataset.eventsModule;
            this._events = url
              ? import(url).then((m) => (m && m.CartLinesUpdateEvent ? m : null)).catch(() => null)
              : Promise.resolve(null);
          }
          return this._events;
        }

        async agregar(boton) {
          if (boton.getAttribute('aria-busy') === 'true') return;
          const variantId = boton.dataset.variantId;
          if (!variantId) return;

          boton.setAttribute('aria-busy', 'true');

          const sectionIds = [];
          document.querySelectorAll('cart-items-component[data-section-id]').forEach((n) => {
            const id = n.dataset.sectionId;
            if (id && sectionIds.indexOf(id) === -1) sectionIds.push(id);
          });

          const events = await this.loadEvents();
          let deferred = null;
          if (events) {
            deferred = events.CartLinesUpdateEvent.createPromise();
            this.dispatchEvent(
              new events.CartLinesUpdateEvent({
                action: 'add',
                context: 'product',
                lines: [{ merchandiseId: variantId, quantity: 1 }],
                promise: deferred.promise,
              })
            );
          }

          try {
            const body = { id: variantId, quantity: 1 };
            if (sectionIds.length) body.sections = sectionIds.join(',');
            const response = await fetch(this.dataset.cartAddUrl || '/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
              body: JSON.stringify(body),
            });
            const payload = await response.json();
            if (payload.status) throw new Error(payload.description || payload.message || '');

            await this.settle(events, deferred, { itemCount: 1, sections: payload.sections, didError: false });
            boton.classList.add('is-added');
            setTimeout(() => boton.classList.remove('is-added'), 1600);

            if (!events) {
              const actions = window.Shopify && window.Shopify.actions;
              if (actions && actions.openCart) actions.openCart();
              else window.location.href = (this.dataset.cartJsonUrl || '/cart.js').replace(/\.js$/, '');
            }
          } catch (error) {
            await this.settle(events, deferred, { itemCount: 1, didError: true });
            // Sin lugar para un mensaje en la tarjeta: mandamos a la PDP, que
            // sí sabe explicar qué pasó (sin stock, límite, etc.).
            const link = boton.parentElement.querySelector('a[href]');
            if (link) window.location.href = link.href;
          } finally {
            boton.setAttribute('aria-busy', 'false');
          }
        }

        async settle(events, deferred, detail) {
          if (!events || !deferred) return;
          try {
            const cart = await fetch(this.dataset.cartJsonUrl || '/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
            deferred.resolve({
              cart: events.CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
              detail: Object.assign({ items: cart.items, source: 'deseado-sabores', sourceId: this.id || 'deseado-sabores' }, detail),
            });
          } catch (error) {
            deferred.reject(error);
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
